import React from "react";
import { Headphones, MessageCircle } from "lucide-react";
import { companyInfo } from "../mock";

const CTABanner = () => {
  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=Hi%20Brahma%20Electrical%2C%20I%20have%20a%20project%20in%20mind.`;
  return (
    <section id="contact" className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-[#0f2a5c] rounded-2xl px-6 md:px-10 py-6 md:py-7 flex flex-col md:flex-row items-center justify-between gap-5 shadow-lg">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 rounded-full bg-[#F5B800] flex items-center justify-center flex-shrink-0">
              <Headphones className="w-7 h-7 text-[#0f2a5c]" />
            </div>
            <div>
              <h3 className="text-white text-xl md:text-2xl font-bold">Have a Project in Mind?</h3>
              <p className="text-slate-200 text-sm md:text-base">Let's build something powerful together.</p>
            </div>
          </div>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb057] text-white font-semibold px-6 py-3 rounded-full transition-colors shadow-md"
          >
            <MessageCircle className="w-5 h-5" fill="white" strokeWidth={0} />
            Chat on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
